import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import Base from "../../../Common/Components/Base";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  card: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    maxWidth: 400,
    background: "#c61236",
    color: "white",
  },
  button: {
    color: "white",
    justifyContent: "center",
    display: "flex",
  },
});

const StudentCancelSlot = ({ data }) => {
  const history = useHistory();
  const onClick = () => {
    history.push({
      pathname: "/dashboard/s-booking/cancel",
    });
  };

  const classes = useStyles();

  return (
    <div onClick={() => onClick()} style={{ cursor: "pointer" }}>
      <Card variant="contained" className={classes.card}>
        <CardContent>
          <>
            <Typography align="center">Cancel Slots</Typography>
            <Typography align="center" variant="h2">
              {data.cancelledSlot}
            </Typography>
          </>
        </CardContent>
      </Card>
    </div>
  );
};

export default StudentCancelSlot;
